
<span
  class="cmp-price-period ws-typography composite-text text-right"
  :class="{ plain }"
>
  <template v-if="actualPrice">
    <small class="price">
      <strong><span v-if="from">{{ $t('general.price_from') }}&nbsp;</span>{{ $n(actualPrice, 'currency') }}</strong>
    </small>
    <span
      class="period ws-typo-xs"
      :class="periodUnder ? 'line-break' : 'inline-block'"
    >&nbsp;<span v-if="between" class="ws-typo-xs">&nbsp;{{ between }}</span><span
      v-if="!periodUnder && verbose"
      class="ws-typo-xs"
    >&nbsp;/&nbsp;</span>&nbsp;{{ $t(periodKey, { count: periodCalc }) }}</span>
  </template>
  <template v-else-if="individual && actualPrice === null">
    <small class="price"><strong>&nbsp;{{ $t('general.price_individual') }}</strong></small>
  </template>
  <template v-else-if="!hideFree">
    <small class="price"><strong>&nbsp;{{ $t('general.price_free') }}</strong></small>
  </template>
</span>
